import { fetchFiber } from 'api';
import React from 'react';
import { useQuery } from 'react-query';

function useFiberFetch() {
  return useQuery({
    queryKey: ['fiber'],
    queryFn: fetchFiber,
  });
}

export default useFiberFetch;
